module.exports = __webpack_public_path__ + "img/couples_03_V.7ff9ee77.webp";